import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './actions';
import { Button, ListGroup, ListGroupItem, Label, Spinner } from 'reactstrap';
import moment from 'moment';

import ReservaConstantes from './constants';

import ExpandableItem, { Detail } from '../../components/ExpandableItem';
import Prompt from '../../components/Prompt';
import Confirm from '../../components/Confirm';
import AuthProvider from '../../AuthProvider';

const missingDays = days => {
  if (-1 === days) return 'Ontem';
  if (0 === days) return 'Hoje';
  if (1 === days) return 'Amanhã';
  if (0 < days) return 'Em ' + days + ' dias';
  return 'Há ' + Math.abs(days) + ' dias';
};

class ReservasEfetuadas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalCancellation: false,
      modalConfirmation: false,
      value: {}
    };

    this.toggleModalCancellation = this.toggleModalCancellation.bind(this);
    this.toggleModalConfirmation = this.toggleModalConfirmation.bind(this);
    this.handleConfirmCancellation = this.handleConfirmCancellation.bind(this);
    this.handleConfirmBooking = this.handleConfirmBooking.bind(this);
  }

  componentDidMount() {
    this.props.actions.onLoadReservas();
  }

  onStartCreateReservas(value) {
    this.setState({
      modalConfirmation: true,
      value
    });
  }

  toggleModalConfirmation() {
    this.setState(({ modalConfirmation }) => ({
      modalConfirmation: !modalConfirmation
    }));
  }

  onStartApproveReservas(value) {
    this.setState({ value });

    this.props.actions.onApproveReservas({
      value
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  onStartCancelReservas(value) {
    if (!value.id && !this.props.guiaInterativo.run) {
      this.props.actions.onRemoveReservas({ value });
    } else {
      this.setState({
        modalCancellation: true,
        value
      });
    }
  }

  toggleModalCancellation() {
    this.setState(({ modalCancellation }) => ({
      modalCancellation: !modalCancellation
    }));
  }

  handleConfirmCancellation(text) {
    this.toggleModalCancellation();

    let value = this.state.value;

    this.props.actions.onCancelReservas({
      value,
      text
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  handleConfirmBooking() {
    this.toggleModalConfirmation();

    let value = this.state.value;

    this.props.actions.onCreateReservas({
      value,
      isNew: false
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  render() {
    let {
      value: { result, fetching, errors, lastModified }
    } = this.props;
    let { modalCancellation, modalConfirmation, value } = this.state;

    return (
      <div>
        <AuthProvider>
          {({ auth: activeAuth }, containsRole, containsUnidade) => {
            let gestao = containsRole(['admin', 'sindico', 'conselheiro']);
            let funcionario = containsRole(['porteiro', 'zelador']);
            let morador = containsUnidade(['morador', 'proprietario']);

            let statusReserva = reserva => {
              switch (reserva.status) {
                case ReservaConstantes.Status.CANCELADA:
                  return reserva.motivo;
                case ReservaConstantes.Status.PENDENTE:
                  return "Aguardando aprovação";
                  //return gestao ? reserva.reservado_por : '';
                case ReservaConstantes.Status.CONFIRMADA:
                  return gestao ? reserva.aprovado_por : '';
                default:
                  return '';
              }
            };

            return (
              <ListGroup>
                {result.map((v, i) => {
                  let date = moment(v.data_reserva);
                  let daysMissing = date.diff(moment().startOf('day'), 'days');

                  return (<ExpandableItem
                    key={i}
                    tag={ListGroupItem}
                    className={
                      'lcr-container-row day-diff-' +
                      Math.abs(daysMissing) +
                      (v.passado ? ' past-event' : '')
                    }
                    color={
                      (v.passado
                        ? ['danger', 'danger', 'success']
                        : ['danger', 'warning', ''])[1 + v.status]
                    }>
                    <div className="d-flex justify-content-between align-items-center"><div>{date.format('DD/MM/YYYY')} : {v.unidade} -{' '}
                    {-1 === v.status?'Cancelado':missingDays(daysMissing)}
                    <br />{statusReserva(v)}</div>
                    {!v.passado && (
                      <div className="text-right">
                        {1 === fetching && value === v && (
                          <Button color="dark" disabled title="Carregando...">
                            <span className="fa fa-calendar" />{' '}
                            <span className="d-none d-sm-inline-block">
                              Carregando...
                            </span>
                          </Button>
                        )}
                        {(1 !== fetching || value !== v) &&
                          ReservaConstantes.Status.CANCELADA === v.status &&
                          (gestao ||
                            funcionario ||
                            0 < morador(v.unidade).length) &&
                          !result.some(
                            (v2, i2) =>
                              v2.unidade === v.unidade &&
                              v2.data_reserva === v.data_reserva &&
                              ReservaConstantes.Status.CANCELADA !== v2.status
                          ) &&
                          i ===
                            result.findIndex(
                              v2 =>
                                v2.unidade === v.unidade &&
                                v2.data_reserva === v.data_reserva
                            ) && (
                            <Button
                              color="success"
                              onClick={() => {
                                this.onStartCreateReservas(v);
                              }}
                              className="lcr-button-reagendar"
                              title="Reagendar!">
                              <span className="fa fa-calendar-plus" />{' '}
                              <span className="d-none d-sm-inline-block">
                                Reagendar!
                              </span>
                            </Button>
                          )}
                        {(1 !== fetching || value !== v) &&
                          ReservaConstantes.Status.PENDENTE === v.status &&
                          gestao && (
                            <Button
                              color="info"
                              onClick={() => {
                                this.onStartApproveReservas(v);
                              }}
                              className="lcr-button-aprovar"
                              title="Aprovar!"
                            >
                              <span className="fa fa-calendar-check" />{' '}
                              <span className="d-none d-sm-inline-block">
                                Aprovar!
                              </span>
                            </Button>
                          )}
                        {(1 !== fetching || value !== v) &&
                          -1 <
                            [
                              ReservaConstantes.Status.CONFIRMADA,
                              ReservaConstantes.Status.PENDENTE
                            ].indexOf(v.status) &&
                          (gestao ||
                            funcionario ||
                            0 < morador(v.unidade).length) && (
                            <Button
                              color="danger"
                              onClick={() => {
                                this.onStartCancelReservas(v);
                              }}
                              className="lcr-button-cancelar"
                              title="Cancelar!"
                            >
                              <span className="fa fa-calendar-times" />{' '}
                              <span className="d-none d-sm-inline-block">
                                Cancelar!
                              </span>
                            </Button>
                          )}
                      </div>
                    )}</div>
                    <Detail>
                      <ul>
                        <li>{v.reservado_por}</li>
                        <li>{v.email_reserva}</li>
                      </ul>
                    </Detail>
                  </ExpandableItem>);
                })}
                {1 === fetching && (
                  <ListGroupItem color="dark">
                    <Spinner size="sm" color="dark" /> Obtendo lista de reservas...
                  </ListGroupItem>
                )}
                {2 === fetching && !result.length && (
                  <ListGroupItem color="success">
                    Não há reservas aprovadas para os próximos dias.
                  </ListGroupItem>
                )}
                {2 === fetching && 0 < result.length && (
                  <ListGroupItem
                    className="lcr-ultima-atualizacao"
                    color="info"
                  >
                    Atualizado em{' '}
                    {moment(lastModified).format('DD/MM/YYYY HH:mm')}
                  </ListGroupItem>
                )}
                {errors.map((error, i) => (
                  <ListGroupItem key={i} color="danger">
                    {error}
                  </ListGroupItem>
                ))}
              </ListGroup>
            );
          }}
        </AuthProvider>
        <Prompt
          headerText="Cancelar Reserva"
          inputProps={{
            placeholder: 'Informe o motivo do cancelamento'
          }}
          valid={v => 3 <= v.length}
          isOpen={modalCancellation}
          toggle={this.toggleModalCancellation}
          onConfirm={this.handleConfirmCancellation}
        />
        <Confirm
          headerText="Confirmar reagendamento"
          labelText={
            <Label>
              Unidade: {value.unidade}
              <br />
              Data: {moment(value.data_reserva).format('DD/MM/YYYY')}
            </Label>
          }
          isOpen={modalConfirmation}
          toggle={this.toggleModalConfirmation}
          onConfirm={this.handleConfirmBooking}
        />
      </div>
    );
  }
}

let mapStateToProps = ({ reserva, guiaInterativo }) => ({
  value: reserva.list,
  guiaInterativo
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservasEfetuadas);



// WEBPACK FOOTER //
// ./src/modules/reserva/ReservasEfetuadas.js